import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
import { PoloHelper } from '@app/_shared/_helpers/polo.helper';
import { GoogleAnalyticsService } from '@app/_shared/_scripts/googleanalytics.service';
import { SmartsuppService } from '@app/_shared/_scripts/smartsupp.service';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { LoadingService } from '@app/_shared/_services/loading.service';
import { environment } from '@environments/environment';
declare var $;
declare var smartsupp: any;
import * as _ from 'underscore';


@Component({
  selector: 'layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {

  body =  document.getElementsByTagName( 'html' )[0];

  superMenuVisible:boolean = false;
  @Input() menuVisible:boolean = true;
  currentUser;
  environment = environment;
  serverSide:boolean = true;

  subscriptions: any[] = [];

  constructor(public poloHelper: PoloHelper, public globalHelper: GlobalHelper,  public loadingService:LoadingService, private authenticationService: AuthenticationService,private renderer: Renderer2,private el: ElementRef
    ,private smartsuppService:SmartsuppService,private googleAnalyticsService: GoogleAnalyticsService
    ) {

      this.subscriptions.push( this.authenticationService.currentUser.subscribe(
        (x) => (this.currentUser = x)
      ));
      // subscribe cookies accepted
      this.subscriptions.push(this.globalHelper.cookiesIsAccepted.subscribe(
        (accepted) => {
          if(accepted){
            this.smartsuppService.loadSmartsupp('652d893f56882977a1881973a21eafd781eeb4b0', 'left');
            this.googleAnalyticsService.loadAnalytics('UA-81827754-1', ['AW-973550474']);
            smartsupp('chat:show');
          }
          else{
          }
        }
      ))

    if(window){
      this.serverSide = false;
    }
    this.loadingService.show()
  }

  ngBeforeViewInit() {
  }
  ngAfterViewInit() {
    // this.body.classList.add('polo');
    // this.body.classList.remove('dashcode');
    this.globalHelper.loadExternalStyles(this.el,'theme/POLO/css/plugins.css','POLO');
    this.globalHelper.loadExternalStyles(this.el,'theme/POLO/css/style.css','POLO');
    setTimeout(() => this.loadingService.hide(), 2000)
  }

  toggleSuperMenu(){
    if(this.currentUser && environment.env != 'extranet')
    this.superMenuVisible = !this.superMenuVisible;
  }
  toggleMenu(){
    this.menuVisible = !this.menuVisible;
  }
  ngOnInit(): void {
    console.log('Home component initialized');
    this.poloHelper.documentReadyFunctions();
    // _smartsupp.hideMobileWidget = false; // hide chat box on mobile devices
    // if(this.globalHelper.CookiesIsAccepted()){
    //   this.smartsuppService.loadSmartsupp('652d893f56882977a1881973a21eafd781eeb4b0', 'left');
    //   this.googleAnalyticsService.loadAnalytics('UA-81827754-1', ['AW-973550474']);
    // }
    if(typeof smartsupp != "undefined")
    smartsupp('chat:show');

  }
  ngOnDestroy(): void {
    if(typeof smartsupp != "undefined")
    smartsupp('chat:hide');
    this.smartsuppService.removeSmartsupp();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get showComparisonPanel(): boolean {
    return environment.enableApiComparison === true && !environment.production;
  }

}
